/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createFilter } from '../../factoriesAny.js';
export var filterDependencies = {
  typedDependencies: typedDependencies,
  createFilter: createFilter
};